export enum ErpTrackingEndpoint {
  Base = '/erp-tracking',
}
